// Modules
import React from 'react';
// Components
import OMInputField from '../../OMComponents/OMInputField/OMInputField';
// Styles
import * as styles from '../PhoneVerificationFormMyAccount.scss';

const VerificationCodeSection = properties => (
  <div key="codeSection" className={styles.codeSection}>
    <div className={styles.title}>{properties.translate('verificationCodeMessage')}</div>
    <div className={styles.inputWrapper}>
      <OMInputField
        maxLength="4"
        placeholder={`${properties.translate('codePlaceholder')}`}
        onChange={properties.onChange}
        isInvalid={!properties.codeIsValid}
        name="verificationCode"
        isValidIfEmpty
        validate={properties.validateCode}
        isRtl={properties.isRtl}
      />
      { (properties.showCodePreloader) && (<span className="icon icon-om-spinner om-pulse" />) }
      { (properties.codeIsVerified) && (<span className="icon icon-check" />) }
    </div>
    { (!properties.codeIsValid && !properties.codeIsVerified)
      ? (
        <div className={styles.invalidMessage}>
          {properties.translate('invalidCodeMessage')}
        </div>
      )
      : null
    }
  </div>
);

export default VerificationCodeSection;
